module.exports = __webpack_public_path__ + "static/media/email-logo-grey 1.b7aa2be4.png";